/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { useEventListener } from "./useEventListener";
import { isMouseEventInElementArea } from "../utils";
import { isFunction, isHTMLElement } from "@adapptio/lib-shared";

export function useBackdropClick(
	onClick: (event: MouseEvent) => void,
	exceptElements: Array<HTMLElement | React.MutableRefObject<HTMLElement>>,
	active = true
): void {
	useEventListener(
		document,
		"click",
		(event) => {
			if (
				exceptElements.every(
					(el) => !isMouseEventInElementArea(event, isHTMLElement(el) ? el : el.current)
				)
			) {
				if (isFunction(onClick)) {
					onClick(event);
				}
			}
		},
		{ capture: true },
		active
	);
}
